import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import { ICountry } from '@app/shared/models/country.model';
import { ValidationPatterns } from '@app/shared/validators/ValidationPatterns';

const phoneValidationDataNetherlands = {
  regex: ValidationPatterns.validDutchPhoneNumberExpression,
  feedbackTextKey: 'SHARED.FORM-INPUTS.CUSTOMER-PHONE-NUMBER-INPUT.ERROR-DUTCH-PHONE-NUMBER-PATTERN'
};

const phoneValidationDataDefault = {
  regex: ValidationPatterns.validPhoneNumberExpression,
  feedbackTextKey: 'SHARED.FORM-INPUTS.CUSTOMER-PHONE-NUMBER-INPUT.ERROR-PHONE-NUMBER-PATTERN'
};

export const phoneNumberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const countryCodeSelect = control.get('country');
  const phoneNumberInput = control.get('mobileNumber');

  if (!countryCodeSelect || !phoneNumberInput) {
    return null;
  }

  if ([null, undefined, ''].indexOf(countryCodeSelect.value) > -1) {
    return null;
  }

  if ([null, undefined, ''].indexOf(phoneNumberInput.value) > -1) {
    return null;
  }

  phoneNumberInput.updateValueAndValidity({ onlySelf: true });

  let supportedCountryValidationData;
  const selectedCountry: ICountry = countryCodeSelect.value;

  switch (selectedCountry.twoLetterIsoCode) {
    case 'NL':
      supportedCountryValidationData = phoneValidationDataNetherlands;
      break;

    default:
      supportedCountryValidationData = phoneValidationDataDefault;
      break;
  }

  if (supportedCountryValidationData.regex.test(phoneNumberInput.value)) {
    return null;
  }

  const validationErrors = { phoneInputFeedback: supportedCountryValidationData.feedbackTextKey };
  phoneNumberInput.setErrors(validationErrors);
  return validationErrors;
};

